import { create } from 'zustand';

// Spring Sale缓存数据接口
interface SpringSaleCacheState {
  recommendList: any[];
  waterfallPosition: number;
  allRecommendListLoaded: boolean;

  // Actions
  setCache: (
    data: Partial<Omit<SpringSaleCacheState, 'setCache' | 'getCache' | 'clearCache'>>,
  ) => void;
  clearCache: () => void;
}

// 创建专用的缓存store（本地store，不需要集成到全局）
export const useSpringSaleCache = create<SpringSaleCacheState>((set) => ({
  // 初始状态
  recommendList: [],
  waterfallPosition: 0,
  allRecommendListLoaded: false,

  // 设置缓存
  setCache: (data) =>
    set((state) => ({
      ...state,
      ...data,
    })),

  // 清除缓存
  clearCache: () =>
    set({
      recommendList: [],
      waterfallPosition: 0,
      allRecommendListLoaded: false,
    }),
}));

// 页面刷新时清除缓存
if (typeof window !== 'undefined') {
  try {
    const perfData = window.performance.getEntriesByType(
      'navigation',
    )[0] as PerformanceNavigationTiming;
    if (perfData?.type === 'reload') {
      // 重置store状态
      useSpringSaleCache.setState({
        recommendList: [],
        waterfallPosition: 0,
        allRecommendListLoaded: false,
      });
    }
  } catch {
    // 忽略错误
  }
}
